import { emit } from "../core/events";

const SCROLL_KEYS = new Set([" ", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"]);

export function installFocusGuard() {
    window.addEventListener("blur", () => emit("pause", {}));
    document.addEventListener("visibilitychange", () => {
        if (document.hidden) emit("pause", {});
    });
    window.addEventListener("keydown", (e) => {
        if (SCROLL_KEYS.has(e.key)) e.preventDefault();
    });
}
